import { entityVerificationDrawerOpenAtom } from '@/atoms/panelAtoms';
import type { NavigatePort } from '@heidi/runtime/shell';
import {
  AutoVerifyCrossSessionWatcher as PackageAutoVerifyCrossSessionWatcher,
  configureEntityVerificationAtoms,
} from '@heidi/session';
import Router from 'next/router';

// Configured at `_app` evaluation so every drawer write reaches the app panel atom.
configureEntityVerificationAtoms({ drawerOpenAtom: entityVerificationDrawerOpenAtom });

const navigateToSession: NavigatePort = (href) => {
  void Router.push(href);
};

export function AutoVerifyCrossSessionWatcher() {
  return <PackageAutoVerifyCrossSessionWatcher onNavigateToSession={navigateToSession} />;
}
